export const NumberHelper = (str: any) => {
    str = `${str}`
    if(str.length <= 0) return 0
    if(str === '0') return 0
    if(str <= 0) return 0
    else
        return str.replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1 ');
}